import { useMenuStore } from '@/stores/menu'

export function useIplusMobileBanner() {
    const store = useMenuStore()
    const { isIplusClosed } = storeToRefs(store)
    const iplusCookie = useCookie('isIplusClosed')

    if (useCookie('isIplusClosed').value) {
        store.setIsIplusClosed(!!useCookie('isIplusClosed').value)
    } else {
        store.setIsIplusClosed(false)
    }

    watch(
        isIplusClosed,
        (val: boolean) => {
            iplusCookie.value = val.toString()
        },
        {
            immediate: true,
        },
    )
}
